<template>
  <div>
    <form data-vv-scope="add">
      <vs-row>
        <vs-col vs-lg="6" vs-sm="12" vs-w="12" class="p-2">
          <label class="vs-input--label">Student</label>
          <v-select :disabled="newStudent" @input="autoFill" v-model="student_details"
            :getOptionLabel="(item) => `${item.basic_details.first_name} ${item.basic_details.last_name}`" class="w-full"
            placeholder="Select Student" :clearable="false" @open="onOpenStudent" @close="onCloseStudent"
            :options="student_list" @search="fetch_list">
            <template v-slot:selected-option="student_list">
              <img v-if="student_list.basic_details.picture" class="person-img rounded-full"
                :src="student_list.basic_details.picture" />
              <img v-else class="person-img rounded-full" src="@/assets/images/pages/user-circle-solid.svg" />
              {{ student_list.basic_details.first_name }}
              {{ student_list.basic_details.last_name }}
            </template>
            <template v-slot:option="student_list">
              <img v-if="student_list.basic_details.picture" class="person-img rounded-full"
                :src="student_list.basic_details.picture" />
              <img v-else class="person-img rounded-full" src="@/assets/images/pages/user-circle-solid.svg" />
              {{ student_list.basic_details.first_name }}
              {{ student_list.basic_details.last_name }}
            </template>
            <template #list-footer>
              <li ref="loadStudent" class="loader" v-show="meta.has_next">
                Loading more students ...
              </li>
            </template>
          </v-select>
        </vs-col>
        <vs-col vs-justify="flex-end" vs-lg="6" vs-sm="12" vs-w="12" class="flex p-2 pt-4">
          <label class="pr-2">Add New Student</label>
          <vs-switch v-model="newStudent" />
        </vs-col>
        <vs-col vs-w="12" class="flex p-2" v-if="newStudent">
          <label class="pr-2">Parent with Minor</label>
          <vs-switch v-model="parentMinor" />
        </vs-col>
        <template v-for="(field, index) in staticFields">

          <div class="p-1" v-if="true" :class="
            slugify(field.field_label) == 'first-name' ||
              slugify(field.field_label) == 'middle-name' ||
              slugify(field.field_label) == 'last-name'
              ? 'lg:w-1/3 sm:w-full'
              : slugify(field.field_label).includes('address')
                ? 'w-full'
                : 'lg:w-1/2 sm:w-full'" :key="index">
            <div>
              <label class="vs-input--label w-full" :class="
                slugify(field.field_label).includes('timezone') ? 'hidden' : ''
              ">{{ field.field_label }}<span v-if="field.enabled_parent" class="required"></span></label>
              <vs-input v-if="!['platform_customer_countries_id', 'platform_timezone_id', 'email', 'mobile'].includes(field.field_name)"
                :disabled="!newStudent && ['first_name', 'middle_name', 'last_name', 'email'].includes(field.field_name)"
                v-validate="field.enabled_parent == true ? 'required' : ''" v-model="client[field.field_name]"
                class="custom_Input" :name="field.field_label" style="width: 100%" />
              <vs-input v-if="field.field_name ==='email'"
                :disabled="!newStudent && ['first_name', 'middle_name', 'last_name', 'email'].includes(field.field_name)"
                v-validate="field.enabled_parent == true ? 'required|email' : 'email'" v-model="client[field.field_name]"
                class="custom_Input" :name="field.field_label" style="width: 100%" />
              <vs-input v-if="field.field_name ==='mobile'"
                :disabled="!newStudent && ['first_name', 'middle_name', 'last_name', 'email'].includes(field.field_name)"
                v-validate="field.enabled_parent == true ? 'required|numeric|length:10' : 'numeric|length:10'" v-model="client[field.field_name]"
                class="custom_Input" :name="field.field_label" style="width: 100%" />
            </div>
            <v-select v-if="
              field.field_name == 'platform_customer_countries_id' &&
              field.field_name != 'platform_timezone_id'
            " v-model="client[field.field_name]" v-validate="field.enabled_parent == true ? 'required' : ''"
              :reduce="(option) => option.id" label="country_name" :name="field.field_label" :options="countryList"
              style="width: 100%" />

            <div class="flex items-center" style="color: rgba(var(--vs-primary), 1); font-size: 12px"
              v-if="field.field_label == 'Phone'">
              <span style="font-size: 14px; margin-right: 2px" class="material-icons-outlined">info</span>Country code is
              mandatory.
            </div>
            <span v-show="errors.has(`add.${field.field_label}`)" class="text-danger ss">
              {{ errors.first(`add.${field.field_label}`) }}
            </span>
          </div>
        </template>

        <dynamic-component v-if="newStudent" ref="children" :custom_fields_required="custom_fields_required"
          validatorScope="add" v-model="dynamicFormObject"></dynamic-component>
      </vs-row>

      <!-- child details -->
      <template v-if="parentMinor">
        <div style="background: #e6f5f6" class="p-4 mt-4">
          <h5 class="p-2">Child Details</h5>
          <div class="flex justify-between items-center">
            <vs-checkbox @change="copyParentToChild" v-model="sameAddress" class="custom_Input w-full mt-4">Same as
              Parent's
              Address</vs-checkbox>
            <div class="inline-flex items-center">
              <vs-icon color="danger" class="cursor-pointer" icon="delete" @click="parentMinor = false" />
              <vs-icon class="cursor-pointer" icon-pack="feather"
                :icon="childCollapse ? 'icon-chevron-down' : 'icon-chevron-left'" style="font-size: 20px"
                @click="childCollapse = !childCollapse" />
            </div>
          </div>
          <template v-if="childCollapse">
            <vs-row>
              <template v-for="childfield in staticChildFields">
                <div class="p-1" v-if="true" :class="
                  slugify(childfield.field_label) == 'first-name' ||
                    slugify(childfield.field_label) == 'middle-name' ||
                    slugify(childfield.field_label) == 'last-name'
                    ? 'lg:w-1/3 sm:w-full'
                    : slugify(childfield.field_label).includes('address')
                      ? 'w-full'
                      : 'lg:w-1/2 sm:w-full'
                " :key="childfield.id">
                  <label class="vs-input--label w-full" :class="
                    slugify(childfield.field_label).includes('timezone')
                      ? 'hidden'
                      : ''
                  ">{{ childfield.field_label }}<span v-if="childfield.enabled_child" class="required"></span></label>
                  <vs-input v-if="
                    !['platform_customer_countries_id','platform_timezone_id', 'dob', 'email', 'mobile'].includes(childfield.field_name)"
                    v-model="client.children[0][childfield.field_name]" v-validate="childfield.enabled_child == true ? 'required' : ''"
                   :data-vv-name="`child ${childfield.field_label}`" :name="`child ${childfield.field_name}`" class="custom_Input"
                    style="width: 100%" />
                  <vs-input v-if="childfield.field_name === email"
                    v-model="client.children[0][childfield.field_name]" v-validate="childfield.enabled_child == true ? 'required|email' : 'email'"
                   :data-vv-name="`child ${childfield.field_label}`" :name="`child ${childfield.field_name}`" class="custom_Input"
                    style="width: 100%" />
                  <vs-input v-if="childfield.field_name === mobile"
                    v-model="client.children[0][childfield.field_name]" v-validate="childfield.enabled_child == true ? 'required|numeric|length:10' : 'numeric|length:10'"
                   :data-vv-name="`child ${childfield.field_label}`" :name="`child ${childfield.field_name}`" class="custom_Input"
                    style="width: 100%" />
                  <flat-pickr v-if="childfield.field_name === 'dob'" v-model="client.children[0][childfield.field_name]"
                    class="w-full" :config="{ maxDate: new Date() }" :name="`child ${childfield.field_name}`"
                    :data-vv-name="`child ${childfield.field_label}`" v-validate="
                      childfield.enabled_child == true ? 'required' : ''
                    "></flat-pickr>

                  <v-select v-if="
                    childfield.field_name ===
                    'platform_customer_countries_id' &&
                    childfield.field_name != 'platform_timezone_id'
                  " v-model="client[childfield.field_name]" :data-vv-name="`child ${childfield.field_label}`"
                    :name="`child ${childfield.field_name}`" v-validate="
                      childfield.enabled_child == true ? 'required' : ''
                    " :reduce="(option) => option.id" label="country_name" :options="countryList"
                    style="background: #fff; width: 100%" />
                  <div class="flex items-center" style="color: rgba(var(--vs-primary), 1); font-size: 12px"
                    v-if="childfield.field_label == 'Phone'" v-validate="'numeric|min:10|max:10'">
                    <span style="font-size: 14px; margin-right: 2px" class="material-icons-outlined">info</span>Country code is mandatory.
                  </div>

                  <span v-show="errors.has(`add.child ${childfield.field_label}`)" class="text-danger">{{
                    errors.first(`add.child ${childfield.field_label}`)
                  }}</span>
                </div>
              </template>
            </vs-row>
          </template>
        </div>
      </template>
    </form>
    <vs-button v-if="newStudent" icon="person_add" class="ml-auto mt-4" @click="createClient">Save</vs-button>
    <vs-button v-else icon="person_add" class="ml-auto mt-4" @click="updateClient">Update</vs-button>
  </div>
</template>

<script>
import { clientList, createClient, updateClient } from '@/api/client.js'
import { DynamicField } from '@/mixins/dynamic-field'
import DynamicComponent from '@/components/common/DynamicComponent'

import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { GetCountryList } from '@/api/common'
import { fetchCustomStaticFields } from '@/api/customfield'

export default {
  mixins: [DynamicField],
  props: {
    clear: false
  },
  watch: {
    clear () {
      if (this.clear) {
        this.student_details = null
      }
    },
    newStudent () {
      if (this.newStudent) {
        this.student_details = null
      }
    }
  },
  data () {
    return {
      table_name: 'student_list',
      dynamicFormObject: {},
      staticChildFields: [],
      staticFields: [],
      parentMinor: false,
      sameAddress: false,
      childCollapse: false,
      newStudent: false,
      student_list: [],
      student_details: null,
      customer_id: localStorage.getItem('customer_id'),
      meta: {
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      countryList: [],
      observerStudent: new IntersectionObserver(this.loadMoreStudent),
      client: {
        client_persona_id: null,
        multi_user: 0,
        first_name: null,
        middle_name: null,
        last_name: null,
        email: null,
        mobile: null,
        address1: null,
        address2: null,
        city: null,
        state: null,
        zip: null,
        platform_customer_countries_id: 1,
        platform_timezone_id: null,
        children: [
          {
            first_name: null,
            middle_name: null,
            last_name: null,
            email: null,
            mobile: null,
            address1: null,
            address2: null,
            city: null,
            state: null,
            zip: null,
            platform_customer_countries_id: 1,
            platform_timezone_id: null,
            dob: null,
            hide: true
          }
        ]
      }
    }
  },
  components: {
    vSelect,
    flatPickr,
    DynamicComponent
  },
  mounted () {
    this.fetch_list()
    this.fetchCountry()
    this.fetch_field_list()
    this.fetch_customfields_list('Client')
  },
  methods: {
    async updateClient () {
      const validateParent = this.$validator.validateAll('add')
      const childDynamicComponent =
        this.$refs.children.$validator.validateAll('add')
      const validateAll = Promise.all([validateParent, childDynamicComponent])
      validateAll.then(async (valid) => {
        if (!valid.includes(false)) {
          try {
            const reqpayload = {
              updateField: {
                first_name: this.client.first_name,
                middle_name: this.client.middle_name,
                last_name: this.client.last_name,
                email: this.client.email,
                mobile: this.client.mobile,
                address: {
                  address1: this.client.address1,
                  address2: this.client.address2,
                  city: this.client.city,
                  state: this.client.state,
                  zip: this.client.zip,
                  platform_customer_countries_id: this.client.platform_customer_countries_id
                },

                bio: this.client.bio,
                social_media: this.client.social_media
              }
            }
            const object1 = {
              dynamic_fields: {}
            }

            object1.dynamic_fields = this.dynamicform
            const payload = Object.assign({}, reqpayload, object1)

            const customer_id = localStorage.getItem('customer_id')

            const { data } = await updateClient(
              this.student_details.basic_details.client_users_id,
              payload,
              customer_id
            )
            this.clientDetails = data.data.clientUser
            this.showSuccessMessage('Updated', 'Student updated successfully', 'success')
          } catch (e) {
            this.showSuccessMessage('Error', e.message, 'danger')
          }
        }
      })
    },
    slugify (string) {
      return string
        ? string
          .toLowerCase()
          .replace(/ /g, '-')
          .replace(/[^\w-]+/g, '')
        : ''
    },
    createClient () {
      const validateParent = this.$validator.validateAll('add')
      const childDynamicComponent =
        this.$refs.children.$validator.validateAll('add')
      const validateAll = Promise.all([validateParent, childDynamicComponent])
      validateAll.then((valid) => {
        if (!valid.includes(false)) {
          try {
            const object1 = {
              dynamic_fields: {}
            }
            object1.dynamic_fields = this.dynamicFormObject
            const payload = Object.assign({}, this.client, object1)

            if (!this.parentMinor) {
              delete payload.children
            }

            payload.multi_user = this.parentMinor ? 1 : 0

            createClient(payload, this.customer_id)
              .then((response) => {
                this.showSuccessMessage('Success', 'Student Created Successfully', 'success')
                this.$emit(
                  'selectedStudent',
                  payload.multi_user == 0 ? response.data.data.clientUser.basic_details.client_users_id : response.data.data.clientUser.basic_details.children[0].child.id
                )
              })
              .catch((api_error) => {
                //
                if (Object.entries(api_error.data.errors) > 0) {
                  for (const [key, value] of Object.entries(
                    api_error.data.errors
                  )) {
                    this.showSuccessMessage('Warning', `${value[0]}`, 'warning')
                  }
                } else {
                  this.showSuccessMessage('Warning', api_error.data.message, 'warning')
                }
              })
          } catch (e) {
            //
          }
        }
      })

    },
    async copyParentToChild () {
      this.client.children[0].address1 = this.client.address1
      this.client.children[0].address2 = this.client.address2
      this.client.children[0].city = this.client.city
      this.client.children[0].state = this.client.state
      this.client.children[0].zip = this.client.zip
      this.client.children[0].platform_customer_countries_id =
        this.client.platform_customer_countries_id
    },
    async fetchCountry () {
      try {
        const { data } = await GetCountryList()
        this.countryList = data.data.countries_list
      } catch (e) {
        //
      }
    },
    async autoFill () {
      this.client.multi_user = this.student_details.basic_details.multi_user
      this.client.first_name = this.student_details.basic_details.first_name
      this.client.middle_name = this.student_details.basic_details.middle_name
      this.client.last_name = this.student_details.basic_details.last_name
      this.client.mobile = this.student_details.basic_details.mobile
      this.client.email = this.student_details.basic_details.email
      this.client.address1 =
        this.student_details.basic_details.address.address1
      this.client.address2 =
        this.student_details.basic_details.address.address2
      this.client.city = this.student_details.basic_details.address.city
      this.client.state = this.student_details.basic_details.address.state
      this.client.zip = this.student_details.basic_details.address.zip
      this.client.platform_customer_countries_id =
        this.student_details.basic_details.address.platform_customer_countries_id
      this.client.platform_timezone_id =
        this.student_details.basic_details.address.platform_timezone_id


      this.$emit(
        'selectedStudent',
        this.student_details.basic_details.client_users_id
      )
    },
    async fetch_list (search) {
      try {
        const payload = {
          name: search
        }
        const { data } = await clientList(
          payload,
          this.meta.current_page,
          this.customer_id,
          null,
          20
        )

        this.student_list = data.data.clientUser
        this.meta = data.data.meta
      } catch (e) {
        //
      }
    },
    async onOpenStudent () {
      if (this.meta.has_next) {
        await this.$nextTick()
        this.observerStudent.observe(this.$refs.loadStudent)
      }
    },
    onCloseStudent () {
      this.observerStudent.disconnect()
    },
    async loadMoreStudent ([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop

        try {
          this.meta.current_page = this.meta.current_page + 1
          const { data } = await clientList(
            {},
            this.meta.current_page,
            this.customer_id,
            null,
            20
          )
          this.student_list.push(...data.data.clientUser)
          this.meta = data.data.meta
        } catch (e) {
          //
        }
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
    async fetch_field_list () {
      try {
        const customerId = this.$store.getters.customerId
        const { data } = await fetchCustomStaticFields(4, customerId, { table_name: this.table_name })
        this.staticFields = data.data.module_fields
        this.staticChildFields = data.data.module_child_fields
        //
      } catch (e) {
        //
      }
    }
  }
}
</script>
